exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-group.send-proposal[data-v-5424e7ee] {\n    text-align: right;\n    margin-top: 15px;\n}\n.form-group.send-proposal label[data-v-5424e7ee] {\n    font-weight: bold;\n    padding-top: 4px;\n    float: right;\n    padding-left: 7px;\n}\n", ""]);

// exports
